var Marketing = /** @class */ (function () {
    function Marketing(props) {
        Object.assign(this, props);
    }
    return Marketing;
}());
export default Marketing;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Marketings/Marketing.ts
// module id = 757
// module chunks = 0